import { memo } from "react";

const TableOfContents = ({ headersList = [], onHeaderClick }) => {
  if (!headersList.length) {
    return null;
  }

  return (
    <div className="licensed-documentation__toc">
      {headersList.map(({ id, title, level }) => (
        <div
          key={id}
          onClick={() => onHeaderClick(id)}
          className={`toc-item ${level === 3 ? "toc-item--h3" : ""}`.trim()}
        >
          {title}
        </div>
      ))}
    </div>
  );
};

export default memo(TableOfContents);
